<fe-empty-container [containerGutter]="'gx-5 gx-md-18'">
    <div class="row row-subtitle">
        <div class="col-12 gy-19">
            <span class="fe-empty-container-title fw-bold">{{
                'fe_precheckin_active_reservation_flight_card_title' | translate
            }}</span>
            &nbsp;
            <span class="fe-empty-container-title">{{
                'fe_precheckin_active_reservation_flight_card_title_optional'
                    | translate
            }}</span>
        </div>
    </div>
    <div class="row">
        <div class="col-12 d-flex align-items-center">
            <span class="fe-empty-container-value">{{
                'fe_precheckin_active_reservation_flight_luk_delay' | translate
            }}</span>
        </div>
    </div>
    <form [formGroup]="formFlightInformation">
        <div class="row">
            <div class="col-12 mb-21 col-sm-6">
                <fe-input
                    [formControlName]="'airlineName'"
                    [label]="
                        'fe_precheckin_active_reservation_flight_name'
                            | translate
                    "
                ></fe-input>
            </div>
            <div class="col-12 mb-21 col-sm-6">
                <fe-input
                    [formControlName]="'flightNumber'"
                    [label]="
                        'fe_precheckin_active_reservation_flight_number'
                            | translate
                    "
                ></fe-input>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6 mb-25">
                <fe-input
                    [formControlName]="'airlineNameReturn'"
                    [label]="
                        'fe_precheckin_active_reservation_flight_name_return'
                            | translate
                    "
                ></fe-input>
            </div>
            <div class="col-12 col-sm-6 mb-25">
                <fe-input
                    [formControlName]="'flightNumberReturn'"
                    [label]="
                        'fe_precheckin_active_reservation_flight_number_return'
                            | translate
                    "
                ></fe-input>
            </div>
        </div>
    </form>
</fe-empty-container>
